import React from 'react';
import { SPEED_RAMPS } from './constants';

const CUSTOM_COLOR = '#a78bfa';

export const SpeedRampCurve = ({ rampId, width = 64, height = 28, active = false, customPoints = null }) => {
  let points, color;

  if (rampId === 'custom' && customPoints && customPoints.length >= 2) {
    points = customPoints;
    color = CUSTOM_COLOR;
  } else {
    const ramp = SPEED_RAMPS[rampId];
    if (!ramp) return null;
    points = ramp.points;
    color = ramp.color;
  }

  const maxSpeed = Math.max(...points.map(p => p[1]), 1.5);
  const pad = 2;
  const innerW = width - pad * 2;
  const innerH = height - pad * 2;

  const coords = points.map(([t, s]) => [
    pad + t * innerW,
    pad + innerH - (s / maxSpeed) * innerH,
  ]);

  const lineD = coords.map((c, i) => `${i === 0 ? 'M' : 'L'} ${c[0].toFixed(1)},${c[1].toFixed(1)}`).join(' ');
  const fillD = `M ${pad},${pad + innerH} ${coords.map(c => `L ${c[0].toFixed(1)},${c[1].toFixed(1)}`).join(' ')} L ${pad + innerW},${pad + innerH} Z`;

  const uid = `rf-${rampId}-${active ? 'a' : 'i'}-${width}`;

  return (
    <svg width={width} height={height} className="flex-shrink-0">
      <defs>
        <linearGradient id={uid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity={active ? 0.45 : 0.15} />
          <stop offset="100%" stopColor={color} stopOpacity={0.02} />
        </linearGradient>
      </defs>
      <path d={fillD} fill={`url(#${uid})`} />
      <path d={lineD} fill="none" stroke={color} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
